import { buildUrl, handleFileRequest  } from '@common/services/requestHelper';
import { RequestType } from '@common/services/types';

const basePath = process.env.REACT_APP_API_PATH;

const getSvgQrCodeForUrl = async (urlToUse: string) => {
  const url = buildUrl(`/qr-code/svg?url=${urlToUse}`, basePath);
  return handleFileRequest({ url, requestType: RequestType.GET})
};

const getPngQrCodeForUrl = async (urlToUse: string, scale: string) => {
  const url = buildUrl(`/qr-code/png/${scale}?url=${urlToUse}`, basePath);
  return handleFileRequest({ url, requestType: RequestType.GET})
};

export { getSvgQrCodeForUrl, getPngQrCodeForUrl };